import {Layout, Steps} from 'antd';
import {getMaintenanceRepairStepStatus,} from '../definition/business';
import React, {Component} from 'react';
import {isBigEnough} from '../helper/uiHelper';
import {injectIntl} from "react-intl";
import connect from "react-redux/es/connect/connect";

const { Content } = Layout;
const { Step } = Steps;

class StepsFragment extends Component {

  render() {
  const { intl:{formatMessage}, sizeClass, stepper } = this.props;
  const isBig = isBigEnough(sizeClass);
  const stepNumber = stepper.steps.indexOf(stepper.currentStep);
  return (
    <Content style={{width: '100%'}}>
      <Steps
        progressDot
        direction={isBig ? 'horizontal' : 'vertical'}
        size={'large' }
        current={stepNumber >= 0 ? stepNumber : 0}
      >
        {stepper.steps.map((step, index) => (
          <Step
            key={index}
            status={getMaintenanceRepairStepStatus(index, stepNumber === -1 ? 0 : stepNumber, stepper.steps)}
            title={formatMessage({ id: `customer.journey.step.${step}` })}
          />
        ))}
      </Steps>
    </Content>)
  };
}

const mapStateToProps = state => ({
  stepper: state.stepper,
});

export default injectIntl(
  connect(
    mapStateToProps
  )(StepsFragment)
);
